import * as React from 'react';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import CssBaseline from '@mui/material/CssBaseline';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import LaunchIcon from '@mui/icons-material/Launch';
import LocationOn from '@mui/icons-material/LocationOn';
import SvgIcon from '@mui/material/SvgIcon';
import axios from 'axios';
//import SearchInput from './components/search/search';
import Paper from '@mui/material/Paper';
import InputBase from '@mui/material/InputBase';
import IconButton from '@mui/material/IconButton';
import SearchIcon from '@mui/icons-material/Search';
import ClearIcon from '@mui/icons-material/Clear';
import { useState } from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import Divider from '@mui/material/Divider';
import './home.css';

const theme = createTheme({
    palette: {
        mode: 'dark',
        action: {
            disabled: 'white'
        }
    }
});

// The circle's path touches all four edges of a 0-24 viewBox with zero margin, so any
// renderer that clips so much as a fractional pixel at the edge (seen in Chrome, position-
// dependent, on pages with 150+ of these icons) cuts directly into the artwork. Padding the
// viewBox out to -2..26 while keeping the path's own coordinates unchanged gives a 2px
// transparent buffer on every side, so that kind of edge-rounding lands in empty space instead.
const SpotifyIcon = (props) => (
    <SvgIcon
        {...props}
        viewBox="-2 -2 28 28"
        width="28"
        height="28"
        style={{ ...props.style, transform: 'translateZ(0)' }}
    >
        <path d="M12 0C5.4 0 0 5.4 0 12s5.4 12 12 12 12-5.4 12-12S18.66 0 12 0zm5.521 17.34c-.24.359-.66.48-1.021.24-2.82-1.74-6.36-2.101-10.561-1.141-.418.122-.779-.179-.899-.539-.12-.421.18-.78.54-.9 4.56-1.021 8.52-.6 11.64 1.32.42.18.479.659.301 1.02zm1.44-3.3c-.301.42-.841.6-1.262.3-3.239-1.98-8.159-2.58-11.939-1.38-.48.12-1.02-.12-1.14-.6-.12-.48.12-1.021.6-1.141C9.6 9.9 15 10.561 18.72 12.84c.361.181.54.78.24 1.2zm.12-3.36C15.24 8.4 8.82 8.16 5.16 9.301c-.6.179-1.2-.181-1.38-.721-.18-.601.18-1.2.72-1.381 4.26-1.26 11.28-1.02 15.721 1.621.539.3.719 1.02.42 1.56-.299.421-1.02.599-1.559.3z" />
    </SvgIcon>
);

const getSpotifyEmbedButton = (card, spotifyArtist, isOpen, onToggle) => {
    if (!spotifyArtist) {
        return null;
    }

    return (
        <>
            <Button style={{
                "display": "flex",
                "margin": "auto",
                "width": "100%",
                "marginBottom": "15px",
                "backgroundColor": "#1DB954",
                "color": "#fff"
            }} variant="contained" size="large" onClick={onToggle}>
                {isOpen ? 'Hide Preview' : 'Preview on Spotify'}
                <SpotifyIcon style={{ "marginLeft": "10px" }} />
            </Button>
            {isOpen && (
                <iframe
                    style={{ "borderRadius": "12px", "marginBottom": "15px" }}
                    src={`https://open.spotify.com/embed/artist/${spotifyArtist.artistId}?utm_source=oembed`}
                    width="100%"
                    height="352"
                    frameBorder="0"
                    allowFullScreen=""
                    allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
                    loading="lazy"
                    title={`Spotify: ${spotifyArtist.artistName}`}
                ></iframe>
            )}
        </>
    );
}

const getButton = (card) => {
    if (card.ticketInformation === null) {
        return <Button style={{
            "display": "flex",
            "margin": "auto",
            "width": "100%",
            "paddingLeft": "40px"
        }} disabled={true} variant="contained" size="large">Sold Out 😞</Button>
    } else if (card.title.includes('Canceled')) {
        return <Button style={{
            "display": "flex",
            "margin": "auto",
            "width": "100%",
            "paddingLeft": "40px"
        }} disabled={true} variant="contained" size="large">Canceled 😞</Button>
    } else {
        return <Button style={{
            "display": "flex",
            "margin": "auto",
            "width": "100%",
            "paddingLeft": "40px"
        }} variant="contained" size="large" onClick={() => {
            window.open(card?.ticketInformation, "_blank");
        }}>Tickets<LaunchIcon style={{ "marginLeft": "10px" }}></LaunchIcon></Button>
    }
}

const getPrice = (price) => {
    if (price === null || price === '') {
        return <Typography style={{ "fontSize": "1.10rem" }}>
            See Tickets Link
        </Typography>
    } else {
        return <Typography style={{ "fontSize": "1.10rem" }}>
            {price}
        </Typography>
    }
}

const getVenueLocation = (venue) => {
    const slowDown = 'https://goo.gl/maps/yXEduTBqv9Dti3QB6';
    const theWaitingRoom = 'https://goo.gl/maps/AN9ZASi5hsrq3mZU9';
    const theAdmiral = 'https://goo.gl/maps/L3tA9shzB8CpeK3u5';
    const theAstro = 'https://maps.app.goo.gl/tpvdai4qJNSuX7Te9';
    const steelhouse = 'https://maps.app.goo.gl/jxBqk7gMKSCmPvYU7';
    let venueLocation;

    switch (venue) {
        case 'Slowdown':
            venueLocation = slowDown;
            break;
        case 'The Waiting Room':
            venueLocation = theWaitingRoom;
            break;
        case 'The Admiral':
            venueLocation = theAdmiral;
            break;
        case 'The Astro':
            venueLocation = theAstro;
            break;
        case 'Steelhouse Omaha':
            venueLocation = steelhouse;
            break;
        default:
            console.log('Unknown venue');
    }
    return venueLocation;
}

const Album = () => {
    const [name, setName] = useState('');
    const [band, setBand] = useState([]);
    const [loading, setLoading] = useState(false);
    // the search result
    const [foundBand, setFoundBand] = useState([]);
    // band title -> { artistId, artistName } | null (null once we know there's no match)
    const [spotifyArtists, setSpotifyArtists] = useState({});
    // band key -> whether its Spotify embed is expanded
    const [openSpotifyEmbeds, setOpenSpotifyEmbeds] = useState({});

    const bandKey = (card) => `${card.title}|${card.venue}|${card.month}|${card.day}`;

    const toggleSpotifyEmbed = (key) => {
        setOpenSpotifyEmbeds((prev) => ({ ...prev, [key]: !prev[key] }));
    };

    const applyFilter = (keyword) => {
        if (keyword !== '') {
            setFoundBand(band.filter((band2) => {
                return band2.title.toLowerCase().includes(keyword.toLowerCase());
            }));
        } else {
            setFoundBand(band);
        }

        setName(keyword);
    };

    const filter = (e) => applyFilter(e.target.value);

    const clearSearch = () => applyFilter('');

    //const [data, setData] = useState([]);
    //const [searchResults, setSearchResults] = useState([]);

    React.useEffect(() => {
        setLoading(true);
        axios.get('/api/getBands').then(response => {
            console.log('response: ', response)
            setBand(response.data);
            setFoundBand(response.data);
            setLoading(false);

            const artistNames = [...new Set(response.data.map((card) => card.title))];

            axios.post('/api/spotify/top-tracks', { artists: artistNames }).then((spotifyResponse) => {
                setSpotifyArtists(spotifyResponse.data);
            }).catch((error) => {
                console.log('spotify lookup failed: ', error);
            });
        });
    }, [setBand]);

    // const callback = useCallback(searchResults => {
    //     const untouchedData = data;
    //     if (searchResults?.name !== '') {
    //         const results = data.filter(band => {
    //             return band.title.toLowerCase().startsWith(searchResults.name.toLowerCase())
    //         });
    //         setData(results);
    //     } else {
    //         setData(untouchedData);
    //     }
    //     console.log(searchResults);
    //     console.log(data);
    //     //setData(data);
    // }, []);

    return (
        <ThemeProvider theme={theme}>
            <CssBaseline />
            <main>
                { }
                <Box style={{ "paddingBottom": "0px" }}
                    sx={{
                        bgcolor: 'rgb(26, 32, 39)',
                        pt: 8,
                        pb: 6,
                    }}
                >
                    <Container maxWidth="sm">
                        <Typography
                            component="h1"
                            variant="h2"
                            align="center"
                            color="white"
                            gutterBottom
                        >
                            Music in Omaha
                        </Typography>
                        <Typography variant="h5" align="center" color="white" paragraph>
                            Bands playing in Omaha that don't suck 🎸
                        </Typography>
                        <br></br>
                        <Paper
                            component="form"
                            sx={{ p: '2px 4px', display: 'flex', alignItems: 'center', width: 'auto' }}
                        >
                            <SearchIcon />
                            <InputBase
                                sx={{ ml: 1, flex: 1 }}
                                placeholder="Search Bands"
                                inputProps={{ 'aria-label': 'search bands' }}
                                value={name}
                                onChange={filter}
                            />
                            {name !== '' && (
                                <IconButton aria-label="clear search" onClick={clearSearch} size="small">
                                    <ClearIcon />
                                </IconButton>
                            )}
                        </Paper>
                    </Container>
                </Box>
                <Container sx={{ py: 8 }} maxWidth="lg">
                    {loading && (
                        <CircularProgress color="inherit" />
                    )}
                    {loading && (
                        <Typography variant="h5" align="center" color="white" paragraph>
                            Loading Bands...
                        </Typography>
                    )}
                    {!loading && foundBand.length === 0 && (
                        <Typography variant="h5" align="center" color="white" paragraph>
                            No bands found 😞
                        </Typography>
                    )}
                    <Grid container alignItems="stretch">
                        <Grid container spacing={4}>
                            {foundBand.map((card, _id) => (
                                <Grid item key={_id} xs={12} sm={6} md={4} lg={3}>
                                    <Card variant="outlined" className={'adjust'}
                                        sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}
                                    >
                                        <CardMedia
                                            style={{
                                                "width": "100%",
                                                "objectFit": "cover",
                                                "objectPosition": "center"
                                            }}
                                            sx={{ height: '260px' }}
                                            component="img"
                                            image={card.image}
                                            alt="Band Image"
                                        />
                                        <CardContent style={{ "paddingBottom": "0" }} sx={{ flexGrow: 1 }}>
                                            <Typography gutterBottom variant="h5" component="h2">
                                                {card.title}
                                            </Typography>
                                            <Divider style={{
                                                "marginBottom": "10px",
                                                "marginTop": "10px"
                                            }}></Divider>
                                            <Grid container style={{
                                                "display": "flex",
                                                "alignItems": "center"
                                            }}
                                                direction={"row"}>
                                                <Grid item style={{ "width": "10%" }}><span style={{ "fontSize": "25px" }}>📅</span></Grid>
                                                <Grid item xs style={{ "marginLeft": "-1rem" }}>{card.dayName === '' && (
                                                    <Typography gutterBottom variant="h6" component="h2" style={{
                                                        "marginBottom": "0px",
                                                        "fontSize": "1.10rem"
                                                    }}>
                                                        {card.month} {card.day}
                                                    </Typography>
                                                )}
                                                    {card.dayName !== '' && (
                                                        <Typography gutterBottom variant="h6" component="h2" style={{
                                                            "marginBottom": "0px",
                                                            "fontSize": "1.10rem"
                                                        }}>
                                                            {card.month} {card.day} - {card.dayName}
                                                        </Typography>
                                                    )}</Grid>
                                            </Grid>
                                            <Divider style={{
                                                "marginBottom": "10px",
                                                "marginTop": "10px"
                                            }}></Divider>
                                            <Grid container style={{
                                                "display": "flex",
                                                "alignItems": "center"
                                            }}
                                                direction={"row"}>
                                                <Grid item style={{ "width": "20%", "marginLeft": "-1rem" }}><span style={{ "fontSize": "25px" }}>⏰</span></Grid>
                                                <Grid item xs style={{ "margin": "-1rem" }}>     <Typography style={{ "fontSize": "1.10rem" }}>
                                                    {card.time}
                                                </Typography></Grid>
                                            </Grid>
                                            <Divider style={{
                                                "marginBottom": "10px",
                                                "marginTop": "10px"
                                            }}></Divider>
                                            <Grid container style={{
                                                "display": "flex",
                                                "alignItems": "center"
                                            }}
                                                direction={"row"}>
                                                <Grid item style={{ "width": "20%", "marginLeft": "-1rem" }}><span style={{ "fontSize": "25px" }}>💵</span></Grid>
                                                <Grid item xs style={{
                                                    "marginRight": "2em",
                                                    "width": "80%"
                                                }}>
                                                    {getPrice(card.price)}
                                                    {/* <Typography>
                                                        {card.price}
                                                    </Typography> */}
                                                </Grid>
                                            </Grid>
                                        </CardContent>
                                        <CardActions style={{ flexDirection: 'column' }}>
                                            {getSpotifyEmbedButton(
                                                card,
                                                spotifyArtists[card.title],
                                                !!openSpotifyEmbeds[bandKey(card)],
                                                () => toggleSpotifyEmbed(bandKey(card))
                                            )}
                                            <Button style={{
                                                "display": "flex",
                                                "margin": "auto",
                                                "width": "100%",
                                                "marginBottom": "15px"
                                            }} variant="outlined" size="large" onClick={() => {
                                                window.open(getVenueLocation(card.venue), "_blank");
                                            }}>{card.venue}<LocationOn style={{ "marginLeft": "10px" }}></LocationOn></Button>
                                            {getButton(card)}
                                        </CardActions>
                                    </Card>
                                </Grid>
                            ))}
                        </Grid>
                    </Grid>
                </Container>
            </main>
            {/* Footer */}
            <Box style={{
                "flexShrink": "0"
            }} sx={{ bgcolor: 'background.paper', p: 6 }} component="footer">
                <Typography variant="h6" align="center" gutterBottom>
                    End of the road
                </Typography>
                <Typography
                    variant="subtitle1"
                    align="center"
                    color="text.secondary"
                    component="p"
                >
                </Typography>
            </Box>
            {/* End footer */}
        </ThemeProvider >
    );
}

export default Album;